import {ChevronLeftIcon} from "@pg-design/icons-module";

import * as styles from "./SimpleSliderArrow.module.css";

export const SimpleSliderArrowLeft = () => {
    return (
        <div className={styles.sliderArrow}>
            <ChevronLeftIcon size="1.2" />
        </div>
    );
};
import {ChevronLeftIcon} from "@pg-design/icons-module";

import * as styles from "./SimpleSliderArrow.module.css";

export const SimpleSliderArrowLeft = () => {
    return (
        <div className={styles.sliderArrow}>
            <ChevronLeftIcon size="1.2" />
        </div>
    );
};
